/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react"; // 1. อย่าลืม import useCallback//import { red } from '@material-ui/core/colors';
import axios from 'axios';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TableFooter,
    TablePagination,
    TextareaAutosize
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { Modal, ModalHeader, ModalBody, Label } from 'reactstrap';
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";


const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
        flexGrow: 1,
    },
    cardTitle: {
        textAlign: 'center'
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
        flexGrow: 1,
    },
    collaps: {
        paddingLeft: '40px',
        paddingTop: '40px',
        display: 'flex',
        flexDirection: 'column-reverse',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        ...StyleSheet.absoluteFillObject,
        alignSelf: 'flex-end',
        position: 'absolute', // add if dont work with above
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    visible: {
        opacity: 1,
        transition: 'opacity 0.5s ease'
    },
    hidden: {
        opacity: 0,
        transition: 'opacity 0.5s ease'
    },
    //avatar: {
    //    backgroundColor: red[500],
    //},
    tableContainer: {
        width: '99.99%',
        overflowX: 'auto', // ทำให้ตารางสามารถเลื่อนในแนวนอนเมื่อกว้างเกินไป
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    tableCell: {
        padding: '2px',
    },
    modalFullscreen: {
        width: '100%',
        height: '100%',
        margin: 0,
        maxWidth: '100%',
    },
    modalContent: {
        height: '100%',
        borderRadius: 0,
    },
    modalBody: {
        overflowY: 'auto',
    },
    pagination: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    cardXs: {
        width: 75,
        height: 110,
        paddingTop: 10,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardSm: {
        width: 180,
        height: 140,
        textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardImg1: {
        width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
    cardImg2: {
        width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
    },
}));


const HASuggestPlanList = () => {
    const tableText = 'แผนงาน Suggest';
    const host = ''; // ใส่ BASE API HOST ที่นี่
    const classes = useStyles();

    const [dataList, setDataList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [orderDirection, setOrderDirection] = useState('asc');
    const [orderBy, setOrderBy] = useState('code');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [isEditing, setIsEditing] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [Keyword, setKeyword] = useState('');

    //#ton900 Array สำหรับเก็บค่า combobox TSSelect2 ของ HASuggest
    const [ArrSuggest, setArrSuggest] = useState([]);
    const [HASuggestKey, setHASuggestKey] = useState(0);
    //

    const ArrRoundType = [{ label:"วัน", value:"day"}, { label:"สัปดาห์", value:"week"} , { label:"เดือน", value:"month"}, { label:"ปี", value:"year"}];

    // 2. หุ้ม fetchDataList ด้วย useCallback และย้าย Dependencies มาใส่ที่นี่แทน
    const fetchDataList = useCallback(async () => {
        try {
            const response = await axios.get(`${host}/api/v1/ha/plans?haSuggestKey=${HASuggestKey}&name=${Keyword}`);
            if (response.data.result === 200) {
                setDataList(response.data.data);
            } else {
                setDataList([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setDataList([]);
        }
    }, [HASuggestKey, Keyword]); // ใส่ตัวแปรที่ใช้ในฟังก์ชันนี้ลงใน dependency array

    useEffect(() => {
        //#ton900 เรียก API HASuggest ใส่ใน ArrSuggest
        // หมายเหตุ: ปกติการโหลด Dropdown ควรแยก useEffect อีกตัวเพื่อให้โหลดแค่ครั้งเดียว (ใส่ [] เป็น dependency) 
        // แต่ถ้า logic นี้ถูกต้องแล้วก็สามารถใช้แบบนี้ได้ครับ
        axios(host + "/api/v1/ha/suggests")
            .then(
                result => {
                    const suggestList = result.data.data.map(item => ({
                        ...item,
                        value: item.haSuggestKey,
                        label: `${item.code}. ${item.name}`
                    }));
                    setArrSuggest(suggestList);
                }, error => { console.log(error); }
            );

        fetchDataList();

    }, [fetchDataList]); // 3. ใส่ fetchDataList ใน dependency array ของ useEffect นี้

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedData = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedData(null);
        setIsEditing(false);
        setEditIndex(null);
    };

    const handleAdd = () => {
        setSelectedData({
            code: '',
            name: '',
            process: '',
            periodTime: '',
            kpi: '',
            trackingStart: '',
            trackingRound: '',
            roundType: ''
        });
        setIsEditing(false);
        setModalOpen(true);
    };

    const handleEdit = (index, item) => {
        setIsEditing(true);
        setSelectedData(item);
        setEditIndex(index);
        setModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedData({ ...selectedData, [name]: value });
    };

    //on selected change
    const handleSelectChange = (name, value) => {
        //กรณี combobox ย่อย
        //if (name == 'HASuggestKey')
        //    fetchCatgory2(value);

        setSelectedData({ ...selectedData, [name]: value });
    };

    const handleSaveChanges = async () => {
        try {
            if (isEditing) {
                await axios.put(`${host}/api/v1/ha/plans/${selectedData.haSuggestPlanKey}`, selectedData);
            } else {
                await axios.post(`${host}/api/v1/ha/plans`, selectedData);
            }
            setModalOpen(false);
            fetchDataList();
        } catch (error) {
            console.error("Error saving data:", error);
        }
    };

    return (
        <div>
            <Grid>
                <Col xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4>รายการ{tableText}</h4>
                        </CardHeader>
                        <CardBody>
                            <Grid>
                                {/* #ton900 combobox TSSelect2 สำหรับ Filter HASuggest  */}
                                <Col xs={12} sm={12} md={12}>
                                    <TSSelect2 isClearable={true} label="ข้อเสนอแนะ" options={ArrSuggest} value={HASuggestKey} onChange={e => setHASuggestKey(e != null ? e.value : '')} />
                                </Col> 
                                <Col xs={12}><TSText label="ค้นหา" value={Keyword} onChange={e => setKeyword(e.target.value)} /></Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <Button2 color="success" onClick={handleAdd}><i className="fa fa-plus"></i> เพิ่ม{tableText}</Button2>
                                </Col>
                            </Grid>
                            <TableContainer component={Paper} className={classes.tableContainer}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <TableSortLabel active={orderBy === 'code'} direction={orderDirection} onClick={() => handleRequestSort('code')}>
                                                    รหัส
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>
                                                <TableSortLabel active={orderBy === 'name'} direction={orderDirection} onClick={() => handleRequestSort('name')}>
                                                    ชื่อแผน
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell>Process</TableCell>
                                            <TableCell>ช่วงเวลา</TableCell>
                                            <TableCell>KPI</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortedData().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                                <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>{data.code}</Button></TableCell>
                                                <TableCell className={classes.tableCell}><Button style={{ textDecoration: 'underline' }} onClick={() => handleEdit(index, data)}>{data.name}</Button></TableCell>
                                                <TableCell className={classes.tableCell}>{data.process}</TableCell>
                                                <TableCell className={classes.tableCell}>{data.periodTime}</TableCell>
                                                <TableCell className={classes.tableCell}>{data.kpi}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                count={dataList.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </CardBody>
                        <CardFooter>
                            <Modal isOpen={modalOpen} toggle={handleCloseModal} className={classes.modalFullscreen}>
                                <ModalHeader toggle={handleCloseModal}></ModalHeader>
                                <ModalBody>
                                    {selectedData && (
                                        <Card>
                                            <CardHeader color="primary">
                                                <h4>{isEditing ? `แก้ไข${tableText}` : `เพิ่ม${tableText}`}</h4>
                                            </CardHeader>
                                            <CardBody>
                                                <Grid>
                                                    <Col xs={12} >
                                                        <TSSelect2 label="ข้อเสนอแนะ" options={ArrSuggest} value={selectedData.haSuggestKey ?? ''} onChange={e => handleSelectChange('haSuggestKey', (e != null ? e.value : ''))} />
                                                    </Col>
                                                    <Col xs={12}><TSText name="code" label="รหัส" value={selectedData.code} onChange={handleInputChange} /></Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <div className="textarea-container" style={{ padding: 0 }}>
                                                            <Label for="Address">ชื่อแผน </Label>  
                                                             <TextareaAutosize 
                                                                name="name"
                                                                className="form-control"
                                                                maxRows={10}
                                                                aria-label="maximum height"
                                                                style={{ width: '100%' }} 
                                                                defaultValue={selectedData.name}
                                                                onChange={handleInputChange}
                                                             />
                                                        </div>
                                                    </Col>

                                                   <Col xs={12} sm={12} md={12}>
                                                        <div className="textarea-container" style={{ padding: 0 }}>
                                                            <Label for="Address">แผนการพัฒนา </Label>  
                                                             <TextareaAutosize 
                                                                name="process"
                                                                className="form-control"
                                                                maxRows={10}
                                                                aria-label="maximum height"
                                                                style={{ width: '100%' }} 
                                                                defaultValue={selectedData.process}
                                                                onChange={handleInputChange}
                                                             />
                                                        </div>
                                                    </Col>
                                                    
                                                    <Col xs={12}><TSText name="periodTime" label="ช่วงเวลา" value={selectedData.periodTime} onChange={handleInputChange} /></Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <div className="textarea-container" style={{ padding: 0 }}>
                                                            <Label for="Address">ตัวชี้วัด </Label>  
                                                             <TextareaAutosize 
                                                                name="kpi"
                                                                className="form-control"
                                                                maxRows={10}
                                                                aria-label="maximum height"
                                                                style={{ width: '100%' }} 
                                                                defaultValue={selectedData.kpi}
                                                                onChange={handleInputChange}
                                                             />
                                                        </div>
                                                    </Col>
                                                    <Col xs={12}><TSText type="tel" name="trackingRound" label="ระยะเวลาการติดตาม" value={selectedData.trackingRound} onChange={handleInputChange} /></Col>
                                                    <Col xs={12} >
                                                        <TSSelect2 label="หน่วยระยะเวลา" options={ArrRoundType} value={selectedData.roundType ?? ''} onChange={e => handleSelectChange('roundType', (e != null ? e.value : ''))} />
                                                    </Col>
                                                </Grid>
                                            </CardBody>
                                            <CardFooter>
                                                <Button2 color="info" onClick={handleSaveChanges}>บันทึก</Button2>
                                                <Button2 color="danger" onClick={handleCloseModal}>ยกเลิก</Button2>
                                            </CardFooter>
                                        </Card>
                                    )}
                                </ModalBody>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
        </div>
    );
};

export default HASuggestPlanList;
